// extracted by mini-css-extract-plugin
export default {"right-panel-wrapper":"LayoutRightPanel_right-panel-wrapper__wHwmQ","rightPanelWrapper":"LayoutRightPanel_right-panel-wrapper__wHwmQ"};